module.exports = __webpack_public_path__ + "img/zproject-3d-model_crop.f81cdc7b.jpg";